export default function Why() {
    return (
        <>
            {/* <hr className="arequipa-hr" /> */}
            <img src="/images/conmu4.jpg" alt="Imagen derecha" className="learn-img" />

            <section className="why">
                <div className="why-container">
                    <div className="why-title">
                        <p>¿A quién está dirigido?</p>
                    </div>

                    <div className="why-text">
                        <p>Este evento es para todas las mujeres que creen en el poder de
                            transformar su entorno desde el conocimiento, la conexión y la acción. </p>
                    </div>

                    <div className="why-bottom">
                        <p className="first">A ti, que eres:</p>
                        <p className="reasons">
                           • <span>Empresaria en crecimiento:</span>  Mujeres como tú hacen historia.<br />
                            • <span>Mujer en marcha: </span> Creando un nuevo liderazgo que inspira.<br />
                            • <span>Estudiante con visión: </span> Lo que hoy sueñas, mañana puede ser tu testimonio.<br />
                            • <span>Líder en formación: </span> Recuerda, otras mujeres como tú ya lo hicieron posible.<br />
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}
